// --> React
import React from 'react';

import './estimateForm.module.scss';

export default function EstimateForm() {
	return (
		<iframe
			src='https://docs.google.com/forms/d/e/1FAIpQLSetVFAXsVcdp8A6R_PL6XYWC1g94Jt60K-EhpT8oe694F3pJQ/viewform?embedded=true'
			width='100%'
			height='100%'
			title='request-estimate'
			frameBorder='0'
			marginHeight='0'
			marginWidth='0'>
			Yükleniyor...
		</iframe>
	);
}
